import { memo } from "react";

import type { SystemTimelineItem } from "@/hooks/useChat";

export const SystemCard = memo(function SystemCard({
  item,
}: {
  item: SystemTimelineItem;
}) {
  return (
    <div className="flex justify-center">
      <span className="rounded-lg bg-white/[0.03] px-3 py-1.5 text-[12px] text-zinc-500">
        {item.text}
      </span>
    </div>
  );
});
